import { Component, Directive, ElementRef, Injector, Input, inject, ChangeDetectionStrategy } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { UpgradeComponent } from "@angular/upgrade/static";

@Directive({
    selector: 'blueprints-list-directive',
    standalone: false,
})
export class BlueprintsListDirective extends UpgradeComponent {
    constructor(elementRef: ElementRef, injector: Injector) {
        super('blueprints', elementRef, injector);
        console.log("BlueprintsListDirective initialized");
    }
}

@Component({
    selector: 'blueprints-list',
    template: '<blueprints-list-directive></blueprints-list-directive>',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BlueprintsListComponent {

}

@Directive({
    selector: 'blueprint-form-directive',
    standalone: false,
})
export class BlueprintFormDirective extends UpgradeComponent {
    @Input() blueprintId: string;

    constructor(elementRef: ElementRef, injector: Injector) {
        super('blueprint', elementRef, injector);
    }
}

@Component({
    selector: 'blueprint-form',
    template: '<blueprint-form-directive [blueprintId]="id"></blueprint-form-directive>',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BlueprintFormComponent {
    @Input() id: string;
}

@Directive({
    selector: 'blueprint-maps-list-directive',
    standalone: false,
})
export class BlueprintMapsListDirective extends UpgradeComponent {
    constructor(elementRef: ElementRef, injector: Injector) {
        super('blueprintMaps', elementRef, injector);
    }
}

@Component({
    selector: 'blueprint-maps-list',
    template: '<blueprint-maps-list-directive></blueprint-maps-list-directive>',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BlueprintMapsListComponent {

}

@Directive({
    selector: 'blueprint-map-edit-directive',
    standalone: false,
})
export class BlueprintMapEditDirective extends UpgradeComponent {
    @Input() id: string;
    @Input() action: string;

    constructor(elementRef: ElementRef, injector: Injector) {
        super('blueprintMapEdit', elementRef, injector);
    }
}

@Component({
    selector: 'blueprint-map-edit',
    template: '<blueprint-map-edit-directive [id]="id" [action]="action"></blueprint-map-edit-directive>',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BlueprintMapEditComponent {
    @Input() id: string;

    protected action: string;

    private route = inject(ActivatedRoute);

    constructor() {
        this.route.data.subscribe(data => {
            this.action = data['action'];
        });
    }
}

@Directive({
    selector: 'blueprint-map-mapping-directive',
    standalone: false,
})
export class BlueprintMapMappingDirective extends UpgradeComponent {
    @Input() id: string;

    constructor(elementRef: ElementRef, injector: Injector) {
        super('blueprintMapMapping', elementRef, injector);
    }
}

@Component({
    selector: 'blueprint-map-mapping',
    template: '<blueprint-map-mapping-directive [id]="id"></blueprint-map-mapping-directive>',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BlueprintMapMappingComponent {
    @Input() id: string;
}
